import { getQureyObjectFromUrl } from './index'

export function goCas () {
    const _tenantId = getQureyObjectFromUrl().tenantId || 1422
    const service = `https://gateway.gaoxiaobang.com/user_info/redirect?redirect=${window.location.origin}${window.location.pathname}`
    window.location.href = `https://cas.gaoxiaobang.com/login?tenantId=${_tenantId}&service=${encodeURIComponent(service)}`
}
